<template>
      <div class="enlarge-icon">
          <template
            v-show="dir === 'enlarge'"
          >

          </template>

          <svg v-show="dir === 'enlarge'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
            <g>
              <g>
                <polyline points="20.596 220 20.596 20 220.596 20" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
                <line x1="14.5957" y1="14.5957" x2="206.4043" y2="206.4043" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
              </g>
              <g>
                <polyline points="281.894 20.298 481.894 20.298 481.894 220.298" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
                <line x1="487.2979" y1="14.2979" x2="295.4894" y2="206.1064" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
              </g>
              <g>
                <polyline points="481.298 280.596 481.298 480.596 281.298 480.596" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
                <line x1="487.2979" y1="486" x2="295.4894" y2="294.1915" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
              </g>
              <g>
                <polyline points="220 480.298 20 480.298 20 280.298" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
                <line x1="14.5957" y1="486.2979" x2="206.4043" y2="294.4894" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
              </g>
            </g>
          </svg>
          <svg v-show="dir === 'shrink'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
            <g>
              <g>
                <polyline points="200.546 0.546 200.546 200.546 0.546 200.546" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
                <line x1="206.5464" y1="205.9506" x2="14.7379" y2="14.1421" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
              </g>
              <g>
                <polyline points="473.249 200.249 273.249 200.249 273.249 0.249" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
                <line x1="267.8443" y1="206.2485" x2="459.6528" y2="14.44" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
              </g>
              <g>
                <polyline points="273.249 471.951 273.249 271.951 473.249 271.951" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
                <line x1="267.2485" y1="266.5464" x2="459.057" y2="458.3549" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
              </g>
              <g>
                <polyline points="0.546 272.249 200.546 272.249 200.546 472.249" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
                <line x1="205.9506" y1="266.2485" x2="14.1421" y2="458.057" style="fill: none;stroke: #eee;stroke-miterlimit: 10;stroke-width: 40px"/>
              </g>
            </g>
          </svg>
        </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    dir: String
  },
  name: 'enlarge-icon',
  data () {
    return {

    }
  },
  components: {

  },
  methods: {

  },
  computed: {
    ...mapGetters({

    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
